import { render, staticRenderFns } from "./TasklistAddTask.vue?vue&type=template&id=0b1cfa54"
import script from "./TasklistAddTask.vue?vue&type=script&lang=js"
export * from "./TasklistAddTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports